import { DataGridColSettings } from '@/components/DataGrid/utils';

export const auditLogsDataGridCols: DataGridColSettings[] = [
  {
    field: 'createdAt',
    headerName: 'Date and time',
    visible: true,
  },
  {
    field: 'username',
    headerName: 'User',
    visible: true,
  },
  {
    field: 'email',
    headerName: 'Email',
    visible: true,
  },
  {
    field: 'action',
    headerName: 'Action',
    visible: true,
  },
  {
    field: 'ipAddress',
    headerName: 'IP Address',
    visible: true,
  },
  {
    field: 'reason',
    headerName: 'Reason',
    visible: true,
  },
];
